<template>
  <div :class="{'loader': true, 'inline': !blocking, 'blocking': blocking}">
    <div class="loader-content">
      <div class="loader-spinner"/>
      <div class="loader-message"><slot>{{ $t('generic.loading') }}</slot></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loader',
  props: {
    blocking: {
      type: Boolean,
      default: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Loader.vue